export * from "../overrides/collapsible";

// soon to be depricated.
import { Collapsible } from "../overrides/collapsible";

export default Collapsible
